import React, { useState } from "react";
import Icon from "./Icon";

export default function Tooltip({ text }) {
  const [visible, setVisible] = useState(false);
  const [enterDialog, setenterDialog] = useState(false);

  return (
    <div 
      className="tooltip-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => {
        setTimeout(() => {
          if (!enterDialog) setVisible(false);
          setenterDialog(false);
        }, 3000);
      }}
    >
      <Icon name="info"/>

      {visible && (
        <div className="tooltip-bubble"
        onMouseEnter={() => setenterDialog(true)}
        onMouseLeave={() =>  setTimeout(() => setVisible(false), 0)}
        >
          <img className="tooltip-arrow" src="/assets/images/flecha_tooltip.png" alt="flecha_tooltip" />
          <div 
          className="tooltip-text"
          dangerouslySetInnerHTML={{__html: text}}
          ></div>
        </div>
      )}
    </div>
  );
}